// extracted by mini-css-extract-plugin
export default {"subtitle":"ChangeTraderPasswordModal_subtitle__6OJJf"};